import ResourcesItemContainer from './ResourcesItemContainer';

export {
    ResourcesItemContainer
};

export default ResourcesItemContainer;